// extracted by mini-css-extract-plugin
module.exports = {"title":"steps-block-module--title--2OOXy","list":"steps-block-module--list--1s1kv","item":"steps-block-module--item--30d_p","itemTitle":"steps-block-module--itemTitle--3RDbK"};